module.exports = __webpack_public_path__ + "static/media/sub-card-label-6.7c2ed896.svg";